// extracted by mini-css-extract-plugin
module.exports = {"root":"TapToBPM_root__CS5_U","btn":"TapToBPM_btn__2BybZ","tapbtn":"TapToBPM_tapbtn__29pzP"};